import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';
import { supabase } from '../lib/supabaseClient';
import AddIcon from '@mui/icons-material/Add';
import { Box, Select, MenuItem, Chip, OutlinedInput } from '@mui/material';
import CustomerModal from './CustomerModal';
import CustomsModal from './CustomsModal';
import CustomsAutocomplete from './CustomsAutocomplete';
import CustomerAutocomplete from './CustomerAutocomplete';
import AddressAutocomplete from './AddressAutocomplete';
import InstructionAutocomplete from './InstructionAutocomplete';
import OperationAuthAutocomplete from './OperationAuthAutocomplete';
import SenderReceiverCompanyAutocomplete from './SenderReceiverCompanyAutocomplete';
import GondericiAliciFirmaModal from './GondericiAliciFirmaModal';

const LoadModal = ({ isOpen, onClose, onSave, load }) => {
  const [formData, setFormData] = useState({
    // General Information
    customerName: '',
    loadReference: '',
    referenceNumber: '',
    senderCompany: '',
    receiverCompany: '',

    // Loading Information
    loadingCompany: '',
    uploadAddress: '',
    loadingCity: '',
    loadingCountry: '',
    loadingReference: '',
    loadingType: '',
    loadingRegion: '',
    loading_date: '',

    // Vehicle Types
    vehicleTypes: [],

    // Discharge Information
    unloadingCompany: '',
    unloadingAddress: '',
    evacuationCity: '',
    dischargeCountry: '',
    dischargeReference: '',

    // Carrier Information (readonly fields)
    driverName: '',
    driverPhone: '',
    towingPlate: '',
    trailerPlate: '',
    //load information
    cargoType: '',
    weight: '',
    volume: '',
    regime: '',
    transitTime: '',

    // Files
    files: [],

    // Load Details
    packageType: '',
    quantity: '',
    product: '',
    netWeight: '',
    grossWeight: '',
    goodsValue: '',
    goodsCurrency: '',

    // Add these new fields
    loadingLatitude: '',
    loadingLongitude: '',
    dischargeLatitude: '',
    dischargeLongitude: '',
    loadingInstructions: '',
    dischargeInstructions: '',
    loadingCustomsAddress: '',
    dischargeCustomsAddress: '',

    // Add on_market to the existing formData state
    on_market: true,

    // Operation authority
    operation_auth_id: '',
  });

  const [fileInput, setFileInput] = useState({
    file: null,
    category: '',
  });

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchBox, setSearchBox] = useState(null);
  const [map, setMap] = useState(null);

  const [mapLoadError, setMapLoadError] = useState(false);
  const [errors, setErrors] = useState({});

  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [viewport, setViewport] = useState({
    center: {
      lat: 41.0082,
      lng: 28.9784,
    },
    zoom: 10,
  });

  const [isMapVisible, setIsMapVisible] = useState(true);

  const googleMapsApiKey = 'AIzaSyDB8KdSyduBU2vadQbJhojnwu5gNsj2f-o'

  const [isDischargeMapVisible, setIsDischargeMapVisible] = useState(true);
  const [dischargeSearchQuery, setDischargeSearchQuery] = useState('');
  const [dischargeSearchResults, setDischargeSearchResults] = useState([]);
  const [selectedDischargeLocation, setSelectedDischargeLocation] =
    useState(null);

  const [savedAddresses, setSavedAddresses] = useState([]);
  console.log(savedAddresses, 'savedAddresses');

  const [openAddressModal, setOpenAddressModal] = useState(false);
  const [newAddress, setNewAddress] = useState({
    name: '',
    description: '',
    city: '',
    state: '',
    country: '',
    latitude: '',
    longitude: '',
  });
  const [addressSearchQuery, setAddressSearchQuery] = useState('');
  const [addressSearchResults, setAddressSearchResults] = useState([]);
  const [isAddressMapVisible, setIsAddressMapVisible] = useState(true);
  const [selectedAddressLocation, setSelectedAddressLocation] = useState(null);

  // Add new state for customs addresses
  const [customsAddresses, setCustomsAddresses] = useState([]);

  // Customs map states
  const [isLoadingCustomsMapVisible, setIsLoadingCustomsMapVisible] = useState(true);
  const [isDischargeCustomsMapVisible, setIsDischargeCustomsMapVisible] = useState(true);
  const [selectedLoadingCustomsLocation, setSelectedLoadingCustomsLocation] = useState(null);
  const [selectedDischargeCustomsLocation, setSelectedDischargeCustomsLocation] = useState(null);

  // Add new state for instruction templates
  const [instructionTemplates, setInstructionTemplates] = useState([]);

  // Add states to track selected saved addresses
  const [selectedLoadingAddressId, setSelectedLoadingAddressId] = useState('');
  const [selectedDischargeAddressId, setSelectedDischargeAddressId] =
    useState('');

  // Add state for customers
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState('');

  // Add state for countries
  const [countries, setCountries] = useState([]);

  // Add state for operation authorities
  const [operationAuths, setOperationAuths] = useState([]);

  // Add state for sender/receiver companies
  const [senderReceiverCompanies, setSenderReceiverCompanies] = useState([]);

  // Add new state for the customs modal
  const [openCustomsModal, setOpenCustomsModal] = useState(false);
  const [selectedCustoms, setSelectedCustoms] = useState(null);

  // Add new state for instruction template modal
  const [openInstructionModal, setOpenInstructionModal] = useState(false);
  const [newInstructionTemplate, setNewInstructionTemplate] = useState({
    name: '',
    content: '',
    type: 'loading', // Default type
  });

  // Add state for customer modal
  const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);

  // Add state for company modal
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);

  // Add after other useEffect hooks
  const vehicleTypeOptions = [
    "Closed Box",
    "Standard Curtain",
    "Refrigerated",
    "ADR",
    "Mega Curtain Trailer",
    "Truck & Trailer",
    "Minivan",
    "Lorry",
    "Out of Gauge (OOG)",
    "Flatbed Trailer",
    "Lowbed",
    "Jumbo Trailer",
    "Swap Body",
    "Tanker",
    "Tilt Trailer"
  ];

  // Add inside the LoadModal component, before the return statement
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);

  // Add this useEffect to check when Google Maps API is loaded
  useEffect(() => {
    const checkGoogleMapsLoaded = () => {
      if (window.google && window.google.maps && window.google.maps.places) {
        setIsGoogleMapsLoaded(true);
      }
    };

    // Check immediately
    checkGoogleMapsLoaded();

    // Also set up an interval to check until it's loaded
    const intervalId = setInterval(() => {
      if (!isGoogleMapsLoaded) {
        checkGoogleMapsLoaded();
      } else {
        clearInterval(intervalId);
      }
    }, 500);

    return () => clearInterval(intervalId);
  }, [isGoogleMapsLoaded]);

  // Add useEffect to fetch customs addresses
  useEffect(() => {
    const fetchCustomsAddresses = async () => {
      try {
        const { data, error } = await supabase.from('customs').select('*');

        if (error) throw error;
        setCustomsAddresses(data || []);
        console.log('Customs addresses loaded:', data);
      } catch (error) {
        console.error('Error fetching customs addresses:', error);
      }
    };

    fetchCustomsAddresses();
  }, []);

  // This useEffect will run when load or customers change
  useEffect(() => {
    if (load) {
      console.log('Setting form data with load:', load);
      console.log('Current customs addresses:', customsAddresses);
      console.log('Current customers:', customers);

      setFormData({
        // General Information
        customerName: load.customer_name || '',
        loadReference: load.formatted_id || '',
        referenceNumber: load.reference_number || '',
        senderCompany: load.sender_company || '',
        receiverCompany: load.receiver_company || '',

        // Loading Information
        loadingCompany: load.loading_company || '',
        uploadAddress: load.pickup_location || '',
        loadingCity: load.loading_city || '',
        loadingCountry: load.loading_country || '',
        loadingType: load.loading_type || '',
        loadingRegion: load.loading_region || '',
        loading_date: load.loading_date || '',

        // Vehicle Types
        vehicleTypes: load.vehicle_type || [],

        // Discharge Information
        unloadingAddress: load.delivery_location || '',
        evacuationCity: load.unloading_city || '',
        dischargeCountry: load.discharge_country || '',

        // Carrier Information
        driverName: load.driver_name || '',
        driverPhone: load.driver_phone || '',
        towingPlate: load.towing_plate || '',
        trailerPlate: load.trailer_plate || '',

        // Load Information
        cargoType: load.cargo_type || '',
        transitTime: load.transit_time || '',

        // Files
        files: load.documents || [],

        // Load Details
        packageType: load.load_details?.package_type || '',
        quantity: load.load_details?.quantity?.toString() || '',
        product: load.load_details?.product || '',
        netWeight: load.load_details?.net_weight?.toString() || '',
        grossWeight: load.load_details?.gross_weight?.toString() || '',
        goodsValue: load.load_details?.goods_value?.toString() || '',
        goodsCurrency: load.load_details?.goods_currency || '',

        // Coordinates and Additional Info
        loadingLatitude: load.loading_latitude?.toString() || '',
        loadingLongitude: load.loading_longitude?.toString() || '',
        dischargeLatitude: load.discharge_latitude?.toString() || '',
        dischargeLongitude: load.discharge_longitude?.toString() || '',
        loadingInstructions: load.loading_instructions || '',
        dischargeInstructions: load.discharge_instructions || '',
        loadingCustomsAddress:
          load.loading_customs_address || load.loading_customs_id || '',
        dischargeCustomsAddress:
          load.discharge_customs_address || load.discharge_customs_id || '',

        // Add on_market to the existing formData setting
        on_market: load.on_market || false,

        // Operation authority
        operation_auth_id: load.operation_auth_id
          ? String(load.operation_auth_id)
          : '',
      });

      // Set map viewport if coordinates exist
      if (load.loading_latitude && load.loading_longitude) {
        setViewport({
          center: {
            lat: parseFloat(load.loading_latitude),
            lng: parseFloat(load.loading_longitude),
          },
          zoom: 14,
        });
        setSelectedLocation({
          lat: parseFloat(load.loading_latitude),
          lng: parseFloat(load.loading_longitude),
        });
      }

      // Set discharge location if coordinates exist
      if (load.discharge_latitude && load.discharge_longitude) {
        setSelectedDischargeLocation({
          lat: parseFloat(load.discharge_latitude),
          lng: parseFloat(load.discharge_longitude),
        });
      }

      // Set loading customs location if the selected customs has coordinates
      const loadingCustomsId = load.loading_customs_address || load.loading_customs_id;
      if (loadingCustomsId && customsAddresses.length > 0) {
        const lc = customsAddresses.find((c) => c.id === loadingCustomsId);
        if (lc?.latitude && lc?.longitude) {
          setSelectedLoadingCustomsLocation({ lat: parseFloat(lc.latitude), lng: parseFloat(lc.longitude) });
          setIsLoadingCustomsMapVisible(true);
        }
      }

      // Set discharge customs location if the selected customs has coordinates
      const dischargeCustomsId = load.discharge_customs_address || load.discharge_customs_id;
      if (dischargeCustomsId && customsAddresses.length > 0) {
        const dc = customsAddresses.find((c) => c.id === dischargeCustomsId);
        if (dc?.latitude && dc?.longitude) {
          setSelectedDischargeCustomsLocation({ lat: parseFloat(dc.latitude), lng: parseFloat(dc.longitude) });
          setIsDischargeCustomsMapVisible(true);
        }
      }
    } else {
      // Reset form when creating new load
      setFormData({
        customerName: '',
        loadReference: '',
        referenceNumber: '',
        senderCompany: '',
        receiverCompany: '',
        loadingCompany: '',
        loadingCity: '',
        loadingCountry: '',
        loadingReference: '',
        uploadAddress: '',
        unloadingCompany: '',
        evacuationCity: '',
        dischargeCountry: '',
        dischargeReference: '',
        unloadingAddress: '',
        driverName: '',
        driverPhone: '',
        towingPlate: '',
        trailerPlate: '',
        cargoType: '',
        weight: '',
        volume: '',
        regime: '',
        files: [],
        loadingRegion: '',
        loadingLatitude: '',
        loadingLongitude: '',
        dischargeLatitude: '',
        dischargeLongitude: '',
        packageType: '',
        quantity: '',
        product: '',
        netWeight: '',
        grossWeight: '',
        goodsValue: '',
        goodsCurrency: '',
        loadingInstructions: '',
        dischargeInstructions: '',
        loadingCustomsAddress: '',
        dischargeCustomsAddress: '',
        on_market: false,
        vehicleTypes: [],
        transitTime: '',
        loading_date: '',
        operation_auth_id: '',
      });

      // Reset locations
      setSelectedLocation(null);
      setSelectedDischargeLocation(null);
      setViewport({
        center: {
          lat: 41.0082,
          lng: 28.9784,
        },
        zoom: 10,
      });

      // Reset customs map states
      setSelectedLoadingCustomsLocation(null);
      setSelectedDischargeCustomsLocation(null);
      setIsLoadingCustomsMapVisible(true);
      setIsDischargeCustomsMapVisible(true);

      // Reset selected address IDs
      setSelectedLoadingAddressId('');
      setSelectedDischargeAddressId('');
    }
  }, [load, customers, customsAddresses]);

  // Separate useEffect to handle address ID setting when savedAddresses changes
  useEffect(() => {
    if (load && savedAddresses.length > 0) {
      // Set loading address ID if it exists in savedAddresses
      const loadingAddress = savedAddresses.find(
        (addr) => addr.description === load.pickup_location
      );
      if (loadingAddress) {
        setSelectedLoadingAddressId(loadingAddress.id.toString());
      }

      // Set discharge address ID if it exists in savedAddresses
      const dischargeAddress = savedAddresses.find(
        (addr) => addr.description === load.delivery_location
      );
      if (dischargeAddress) {
        setSelectedDischargeAddressId(dischargeAddress.id.toString());
      }
    }
  }, [savedAddresses, load?.pickup_location, load?.delivery_location]);

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const { data, error } = await supabase.from('addresses').select('*');
        console.log(data, 'data');
        if (error) throw error;
        setSavedAddresses(data || []);
      } catch (error) {
        console.error('Error fetching addresses:', error);
      }
    };

    fetchAddresses();
  }, []);

  useEffect(() => {
    const fetchInstructionTemplates = async () => {
      try {
        const { data, error } = await supabase
          .from('instruction_templates')
          .select('*');

        if (error) throw error;
        setInstructionTemplates(data || []);
      } catch (error) {
        console.error('Error fetching instruction templates:', error);
      }
    };

    fetchInstructionTemplates();
  }, []);

  // Fetch countries from Supabase
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const { data, error } = await supabase
          .from('countries')
          .select('*')
          .order('sort_order', { ascending: true })
          .order('name_tr', { ascending: true });

        if (error) throw error;
        setCountries(data || []);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };

    fetchCountries();
  }, []);

  // Fetch customers from the database
  const fetchCustomers = async () => {
    try {
      const { data, error } = await supabase
        .from('customers')
        .select('*')
        .eq('active', true)
        .order('name');

      if (error) throw error;
      setCustomers(data || []);

      // If editing a load, set the selected customer
      if (load && load.customer_name) {
        const customer = data?.find((c) => c.name === load.customer_name);
        if (customer) {
          setSelectedCustomerId(customer.id);
        }
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  // Handle customer modal
  const handleOpenCustomerModal = () => {
    setIsCustomerModalOpen(true);
  };

  const handleCustomerSave = () => {
    fetchCustomers(); // Refresh the customers list after saving
    setIsCustomerModalOpen(false);
  };

  // Handle company modal
  const handleOpenCompanyModal = () => {
    setIsCompanyModalOpen(true);
  };

  const handleCompanySave = () => {
    fetchSenderReceiverCompanies(); // Refresh the companies list after saving
    setIsCompanyModalOpen(false);
  };

  // Fetch operation authorities from the database
  const fetchOperationAuths = async () => {
    try {
      const { data, error } = await supabase
        .from('operation_auths')
        .select('*')
        .order('name');

      if (error) throw error;
      setOperationAuths(data || []);
    } catch (error) {
      console.error('Error fetching operation authorities:', error);
    }
  };

  // Fetch sender/receiver companies from the database
  const fetchSenderReceiverCompanies = async () => {
    try {
      const { data, error } = await supabase
        .from('sender_receiver_companies')
        .select('*')
        .eq('active', true)
        .order('name');

      if (error) throw error;
      setSenderReceiverCompanies(data || []);
    } catch (error) {
      console.error('Error fetching sender/receiver companies:', error);
    }
  };

  useEffect(() => {
    fetchCustomers();
    fetchOperationAuths();
    fetchSenderReceiverCompanies();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Special handling for date fields to ensure proper timezone
    if ((name === 'dischargeDate' || name === 'loading_date') && value) {
      // Create a date object and format it as ISO string
      const date = new Date(value);
      setFormData((prev) => ({
        ...prev,
        [name]: date.toISOString(),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleFileAdd = () => {
    if (!fileInput.file || !fileInput.category) {
      alert('Lütfen dosya ve kategori seçiniz');
      return;
    }

    setFormData((prev) => ({
      ...prev,
      files: [
        ...prev.files,
        {
          name: fileInput.file.name,
          category: fileInput.category,
          file: fileInput.file,
        },
      ],
    }));

    // Reset file input
    setFileInput({ file: null, category: '' });
  };

  const removeFile = (index) => {
    setFormData((prev) => ({
      ...prev,
      files: prev.files.filter((_, i) => i !== index),
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    // General Information validation
    if (!formData.customerName?.trim()) {
      newErrors.customerName = 'Müşteri adı gereklidir';
    }

    // Loading Information validation
    if (!formData.uploadAddress?.trim()) {
      newErrors.uploadAddress = 'Yükleme adresi gereklidir';
    }

    if (!formData.loadingCountry?.trim()) {
      newErrors.loadingCountry = 'Yükleme ülkesi gereklidir';
    }

    if (!formData.loadingCity?.trim()) {
      newErrors.loadingCity = 'Yükleme şehri gereklidir';
    }

    if (!formData.loading_date?.trim()) {
      newErrors.loading_date = 'Yükleme tarihi gereklidir';
    }
/* 
    // Vehicle Types validation
    if (!formData.vehicleTypes || formData.vehicleTypes.length === 0) {
      newErrors.vehicleTypes = 'En az bir araç tipi seçilmelidir';
    }
     */

    // Discharge Information validation
    if (!formData.unloadingAddress?.trim()) {
      newErrors.unloadingAddress = 'Boşaltma adresi gereklidir';
    }

    if (!formData.evacuationCity?.trim()) {
      newErrors.evacuationCity = 'Boşaltma şehri gereklidir';
    }

    if (!formData.dischargeCountry?.trim()) {
      newErrors.dischargeCountry = 'Boşaltma ülkesi gereklidir';
    }

    if (!formData.product?.trim()) {
      newErrors.product = 'Taşınan ürün gereklidir';
    }


/* 
    // Load Details validation - Check if at least some load details are provided
    const hasLoadDetails =
      formData.packageType?.trim() ||
      formData.product?.trim() ||
      formData.quantity?.trim() ||
      formData.netWeight?.trim() ||
      formData.grossWeight?.trim();

    if (!hasLoadDetails) {
      newErrors.loadDetails =
        'En az bir yük detayı bilgisi girilmelidir (Paket Tipi, Ürün, Miktar, Net Ağırlık veya Brüt Ağırlık)';
    }
*/
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onLoad = (autocomplete) => {
    setSearchBox(autocomplete);
  };

  const onPlaceChanged = () => {
    if (searchBox) {
      const place = searchBox.getPlace();
      if (place.geometry) {
        const location = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        setSelectedLocation(location);
        setFormData((prev) => ({
          ...prev,
          uploadAddress: place.formatted_address,
          loadingCity:
            place.address_components.find((c) => c.types.includes('administrative_area_level_1'))
              ?.long_name || '',
          loadingCountry:
            place.address_components.find((c) => c.types.includes('country'))
              ?.short_name || '',
        }));

        if (map) {
          map.panTo(location);
          map.setZoom(15);
        }
      }
    }
  };

  const onMapClick = (e) => {
    const location = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    setSelectedLocation(location);

    // Reverse geocode the clicked location
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location }, (results, status) => {
      if (status === 'OK' && results[0]) {
        setFormData((prev) => ({
          ...prev,
          uploadAddress: results[0].formatted_address,
          loadingCity:
            results[0].address_components.find((c) =>
              c.types.includes('administrative_area_level_1')
            )?.long_name || '',
          loadingCountry:
            results[0].address_components.find((c) =>
              c.types.includes('country')
            )?.short_name || '',
        }));
      }
    });
  };

  const handleLoadError = () => {
    setMapLoadError(true);
    console.error('Failed to load Google Maps');
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate the form
    if (validateForm()) {
      // Create a copy of formData and convert empty strings to null for numeric fields
      const processedData = {
        ...formData,
        quantity: formData.quantity ? parseInt(formData.quantity) : null,
        netWeight: formData.netWeight ? parseFloat(formData.netWeight) : null,
        grossWeight: formData.grossWeight
          ? parseFloat(formData.grossWeight)
          : null,
        goodsValue: formData.goodsValue
          ? parseFloat(formData.goodsValue)
          : null,
        volume: formData.volume ? parseFloat(formData.volume) : null,
        weight: formData.weight ? parseFloat(formData.weight) : null,
        transitTime: formData.transitTime,
        operation_auth_id: formData.operation_auth_id || null,
      };
      onSave(processedData);

      // Reset location-related states
      setSelectedLocation(null);
      setSelectedDischargeLocation(null);
      setSearchQuery('');
      setSearchResults([]);
      setDischargeSearchQuery('');
      setDischargeSearchResults([]);
      setIsMapVisible(true);
      setIsDischargeMapVisible(false);
      setViewport({
        center: {
          lat: 41.0082,
          lng: 28.9784,
        },
        zoom: 10,
      });
    } else {
      // Show detailed warning message about missing required fields
      const errorCount = Object.keys(errors).length;
      const errorMessage = `Lütfen ${errorCount} adet zorunlu alanı doldurunuz. Eksik alanlar kırmızı ile işaretlenmiştir.`;

      // Show alert with the warning message
      alert(errorMessage);

      // Scroll to the first error
      const firstError = document.querySelector('.error-message');
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  };

  const renderInput = (
    name,
    label,
    type = 'text',
    readonly = false,
    required = true
  ) => {
    let value = formData[name];

    // Handle empty numeric values
    if (type === 'number' && value === '') {
      value = '';
    }

    // Format date for display in input
    if (type === 'date' && value) {
      try {
        value = new Date(value).toISOString().split('T')[0];
      } catch (e) {
        value = '';
      }
    }

    return (
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}{' '}
          {!readonly && required && <span className="text-red-500">*</span>}
        </label>
        <input
          type={type}
          name={name}
          value={value}
          onChange={handleChange}
          readOnly={readonly}
          min={type === 'number' ? '0' : undefined}
          step={type === 'number' ? 'any' : undefined}
          className={`w-full px-3 py-2 border rounded-md ${
            readonly
              ? 'bg-gray-100'
              : 'focus:outline-none focus:ring-2 focus:ring-blue-500'
          } ${errors[name] ? 'border-red-500' : 'border-gray-300'}`}
        />
        {errors[name] && (
          <p className="error-message text-red-500 text-xs mt-1">
            {errors[name]}
          </p>
        )}
      </div>
    );
  };

  const renderTextArea = (name, label, required = false) => {
    const isLoadingInstructions = name === 'loadingInstructions';
    const isDischargeInstructions = name === 'dischargeInstructions';
    const showTemplates = isLoadingInstructions || isDischargeInstructions;

    const handleTemplateSelect = (e) => {
      const templateId = e.target.value;
      if (!templateId) return;

      const selectedTemplate = instructionTemplates.find(
        (template) => template.id === parseInt(templateId)
      );

      if (selectedTemplate) {
        setFormData((prev) => ({
          ...prev,
          [name]: selectedTemplate.content,
        }));
      }
    };

    const handleNewInstructionClick = (type) => {
      setNewInstructionTemplate({
        name: '',
        content: '',
        type: type, // 'loading' or 'discharge'
      });
      setOpenInstructionModal(true);
    };

    return (
      <div className="col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-1 flex justify-between items-center">
          <span>
            {label} {required && <span className="text-red-500">*</span>}
          </span>
          {showTemplates && (
            <button
              type="button"
              onClick={() =>
                handleNewInstructionClick(
                  isLoadingInstructions ? 'loading' : 'discharge'
                )
              }
              className="text-blue-600 text-sm hover:text-blue-800 flex items-center"
            >
              <AddIcon className="w-4 h-4 mr-1" />
              Yeni Şablon Ekle
            </button>
          )}
        </label>

        {showTemplates && (
          <div className="mb-2">
            <select
              onChange={handleTemplateSelect}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Şablon seçiniz...</option>
              {instructionTemplates
                .filter(
                  (template) =>
                    (isLoadingInstructions && template.type === 'loading') ||
                    (isDischargeInstructions && template.type === 'discharge')
                )
                .map((template) => (
                  <option key={template.id} value={template.id}>
                    {template.name}
                  </option>
                ))}
            </select>
          </div>
        )}

        <textarea
          name={name}
          value={formData[name]}
          onChange={handleChange}
          rows={4}
          className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
            errors[name] ? 'border-red-500' : 'border-gray-300'
          }`}
        />
        {errors[name] && (
          <p className="error-message text-red-500 text-xs mt-1">
            {errors[name]}
          </p>
        )}
      </div>
    );
  };

  const renderSelect = (name, label, options, required, readonly = false) => (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <select
        name={name}
        value={formData[name]}
        onChange={handleChange}
        disabled={readonly}
        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
          errors[name] ? 'border-red-500' : 'border-gray-300'
        } ${readonly ? 'bg-gray-100 cursor-not-allowed' : ''}`}
      >
        <option value="">{label} seçiniz</option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errors[name] && (
        <p className="error-message text-red-500 text-xs mt-1">
          {errors[name]}
        </p>
      )}
    </div>
  );

  const handleLocationSelect = (prediction) => {
    const service = new window.google.maps.places.PlacesService(
      document.createElement('div')
    );

    service.getDetails({ placeId: prediction.place_id }, (place, status) => {
      if (status === 'OK' && place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        setSelectedLocation({ lat, lng });
        setViewport({
          zoom: 14,
          center: { lat, lng },
        });

        setFormData((prev) => ({
          ...prev,
          uploadAddress: place.formatted_address,
          loadingCity:
            place.address_components.find((c) => c.types.includes('administrative_area_level_1'))
              ?.long_name || '',
          loadingCountry:
            place.address_components.find((c) => c.types.includes('country'))
              ?.short_name || '',
          loadingLatitude: lat.toString(),
          loadingLongitude: lng.toString(),
        }));

        setSearchResults([]);
        setSearchQuery(place.formatted_address);
      }
    });
  };

  useEffect(() => {
    const searchLocation = async () => {
      if (!searchQuery) {
        setSearchResults([]);
        return;
      }

      // Check if Google Maps API is loaded
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        console.warn('Google Maps API not loaded yet');
        return;
      }

      const service = new window.google.maps.places.AutocompleteService();
      service.getPlacePredictions(
        { input: searchQuery },
        (predictions, status) => {
          if (status === 'OK') {
            setSearchResults(predictions);
          } else {
            setSearchResults([]);
          }
        }
      );
    };

    const timeoutId = setTimeout(searchLocation, 300);
    return () => clearTimeout(timeoutId);
  }, [searchQuery]);

  const handleDischargeLocationSelect = (result) => {
    const [lng, lat] = result.center;
    setSelectedDischargeLocation({ lat, lng });
    setViewport({
      zoom: 14,
      center: { lat, lng },
    });

    setFormData((prev) => ({
      ...prev,
      unloadingAddress: result.place_name,
      evacuationCity:
        result.context?.find((c) => c.id.includes('place'))?.text || '',
      dischargeCountry:
        result.context
          ?.find((c) => c.id.includes('country'))
          ?.short_code?.toUpperCase() || '',
      dischargeLatitude: lat.toString(),
      dischargeLongitude: lng.toString(),
    }));
    setDischargeSearchResults([]);
    setDischargeSearchQuery(result.place_name);
  };

  useEffect(() => {
    const searchDischargeLocation = async () => {
      if (!dischargeSearchQuery) {
        setDischargeSearchResults([]);
        return;
      }

      try {
        const response = await axios.get(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
            dischargeSearchQuery
          )}.json?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`
        );
        setDischargeSearchResults(response.data.features);
      } catch (error) {
        console.error('Error searching location:', error);
        setDischargeSearchResults([]);
      }
    };

    const timeoutId = setTimeout(searchDischargeLocation, 300);
    return () => clearTimeout(timeoutId);
  }, [dischargeSearchQuery]);

  const handleSavedAddressSelect = (addressData, type) => {
    if (type === 'loading') {
      setFormData((prev) => ({
        ...prev,
        uploadAddress: addressData.description || '',
        loadingCity: addressData.city || '',
        loadingCountry: addressData.country || '',
        loadingCompany: addressData.company_name || '',
        loadingLatitude: addressData.latitude?.toString() || '',
        loadingLongitude: addressData.longitude?.toString() || '',
        loadingReference: addressData.reference || '',
        loadingRegion: addressData.state || '',
        loadingInstructions: addressData.instructions || '',
        loadingCustomsAddress: addressData.customs_address || '',
      }));

      if (addressData.latitude && addressData.longitude) {
        setSelectedLocation({
          lat: parseFloat(addressData.latitude),
          lng: parseFloat(addressData.longitude),
        });
        setViewport({
          center: {
            lat: parseFloat(addressData.latitude),
            lng: parseFloat(addressData.longitude),
          },
          zoom: 14,
        });
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        unloadingAddress: addressData.description || '',
        evacuationCity: addressData.city || '',
        dischargeCountry: addressData.country || '',
        unloadingCompany: addressData.company_name || '',
        dischargeLatitude: addressData.latitude?.toString() || '',
        dischargeLongitude: addressData.longitude?.toString() || '',
        dischargeReference: addressData.reference || '',
        dischargeInstructions: addressData.instructions || '',
        dischargeCustomsAddress: addressData.customs_address || '',
      }));

      if (addressData.latitude && addressData.longitude) {
        setSelectedDischargeLocation({
          lat: parseFloat(addressData.latitude),
          lng: parseFloat(addressData.longitude),
        });
        setViewport({
          center: {
            lat: parseFloat(addressData.latitude),
            lng: parseFloat(addressData.longitude),
          },
          zoom: 14,
        });
      }
    }

    // Update search queries with description instead of address
    if (type === 'loading') {
      setSearchQuery(addressData.description || '');
      setSearchResults([]);
    } else {
      setDischargeSearchQuery(addressData.description || '');
      setDischargeSearchResults([]);
    }
  };

  // Add this new function after handleChange
  const handleCustomsAddressCheckbox = (e) => {
    if (e.target.checked) {
      setFormData((prev) => ({
        ...prev,
        loadingCustomsAddress: prev.uploadAddress,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        loadingCustomsAddress: '',
      }));
    }
  };

  // Add this new handler function near handleCustomsAddressCheckbox
  const handleDischargeCustomsAddressCheckbox = (e) => {
    if (e.target.checked) {
      setFormData((prev) => ({
        ...prev,
        dischargeCustomsAddress: prev.unloadingAddress,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        dischargeCustomsAddress: '',
      }));
    }
  };

  // Add this new function to handle address creation
  const handleAddAddress = async () => {
    try {
      const { error } = await supabase.from('addresses').insert([newAddress]);
      if (error) throw error;

      // Refresh the addresses list
      const { data: newAddresses } = await supabase
        .from('addresses')
        .select('*');
      setSavedAddresses(newAddresses || []);

      // Reset and close modal
      setNewAddress({
        name: '',
        description: '',
        city: '',
        state: '',
        country: '',
        latitude: '',
        longitude: '',
      });
      setOpenAddressModal(false);
    } catch (error) {
      console.error('Error saving address:', error.message);
    }
  };

  // Add this function to handle address search results selection
  const handleAddressLocationSelect = (result) => {
    const [lng, lat] = result.center;
    setSelectedAddressLocation({ lng, lat });
    setNewAddress((prev) => ({
      ...prev,
      description: result.place_name,
      city: result.context?.find((c) => c.id.includes('place'))?.text || '',
      country:
        result.context
          ?.find((c) => c.id.includes('country'))
          ?.short_code?.toUpperCase() || '',
      latitude: lat.toString(),
      longitude: lng.toString(),
    }));
    setAddressSearchResults([]);
    setAddressSearchQuery(result.place_name);
  };

  // Add this effect for address search
  useEffect(() => {
    const searchAddress = async () => {
      if (!addressSearchQuery) {
        setAddressSearchResults([]);
        return;
      }

      try {
        const response = await axios.get(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
            addressSearchQuery
          )}.json?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`
        );
        setAddressSearchResults(response.data.features);
      } catch (error) {
        console.error('Error searching address:', error);
        setAddressSearchResults([]);
      }
    };

    const timeoutId = setTimeout(searchAddress, 300);
    return () => clearTimeout(timeoutId);
  }, [addressSearchQuery]);

  // Replace the loading customs address input with autocomplete
  const renderCustomsAddressSelect = (type) => {
    const fieldName =
      type === 'loading' ? 'loadingCustomsAddress' : 'dischargeCustomsAddress';
    const label = type === 'loading' ? 'Yükleme Gümrüğü' : 'Varış Gümrüğü';
    const mapToggleLabel =
      type === 'loading'
        ? 'Yükleme Gümrüğünü Haritada Göster'
        : 'Varış Gümrüğünü Haritada Göster';
    const isMapVisible =
      type === 'loading' ? isLoadingCustomsMapVisible : isDischargeCustomsMapVisible;
    const setMapVisible =
      type === 'loading' ? setIsLoadingCustomsMapVisible : setIsDischargeCustomsMapVisible;
    const selectedCustomsLocation =
      type === 'loading' ? selectedLoadingCustomsLocation : selectedDischargeCustomsLocation;
    const setSelectedCustomsLocation =
      type === 'loading' ? setSelectedLoadingCustomsLocation : setSelectedDischargeCustomsLocation;

    return (
      <div className="space-y-2">
        <CustomsAutocomplete
          value={formData[fieldName]}
          onChange={(value) => {
            setFormData((prev) => ({
              ...prev,
              [fieldName]: value,
            }));
            // Find the selected customs and update the map location
            const customs = customsAddresses.find((c) => c.id === value);
            if (customs?.latitude && customs?.longitude) {
              setSelectedCustomsLocation({
                lat: parseFloat(customs.latitude),
                lng: parseFloat(customs.longitude),
              });
              setMapVisible(true);
            } else {
              setSelectedCustomsLocation(null);
            }
          }}
          options={customsAddresses}
          label={label}
          onAddNew={() => {
            setSelectedCustoms(null);
            setOpenCustomsModal(true);
          }}
          placeholder={
            type === 'loading' ? 'Yükleme gümrüğü ara...' : 'Varış gümrüğü ara...'
          }
        />

        {/* Map toggle button for customs location */}
        <button
          type="button"
          onClick={() => setMapVisible(!isMapVisible)}
          className="w-full px-4 py-2 text-left text-sm font-medium text-green-700 bg-green-50 hover:bg-green-100 rounded-md flex items-center justify-between"
        >
          <span>{mapToggleLabel}</span>
          <svg
            className={`w-5 h-5 transform transition-transform ${isMapVisible ? 'rotate-180' : ''}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        {/* Map section for customs location */}
        {isMapVisible && (
          <div className="relative h-[280px] rounded-md border border-green-200">
            {selectedCustomsLocation ? (
              <APIProvider apiKey={googleMapsApiKey} libraries={['places']}>
                <Map
                  defaultZoom={13}
                  defaultCenter={selectedCustomsLocation}
                  gestureHandling="greedy"
                  disableDefaultUI={true}
                  style={{ width: '100%', height: '100%' }}
                >
                  <Marker position={selectedCustomsLocation} />
                </Map>
              </APIProvider>
            ) : (
              <div className="flex items-center justify-center h-full bg-gray-50 text-sm text-gray-400">
                <div className="text-center">
                  <svg className="w-10 h-10 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <p>Seçili gümrük için koordinat bilgisi bulunamadı</p>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Add this function to handle the switch change
  const handleMarketSwitch = (event) => {
    setFormData((prev) => ({
      ...prev,
      on_market: event.target.checked,
    }));
  };

  // Add a reusable function to find address from coordinates
  const findAddressFromCoordinates = (lat, lng, addressType) => {
    if (!isNaN(lat) && !isNaN(lng)) {
      // Set the appropriate map marker and viewport based on address type
      if (addressType === 'loading') {
        setSelectedLocation({ lat, lng });
        setIsMapVisible(true);
      } else if (addressType === 'discharge') {
        setSelectedDischargeLocation({ lat, lng });
        setIsDischargeMapVisible(true);
      } else if (addressType === 'new') {
        setSelectedAddressLocation({ lat, lng });
        setIsAddressMapVisible(true);
      }

      // Update viewport to center on this location
      setViewport({
        center: { lat, lng },
        zoom: 14,
      });

      // Now reverse geocode to get the address
      if (window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === 'OK' && results[0]) {
            const addressComponents = results[0].address_components;

            // Update the appropriate fields based on address type
            if (addressType === 'loading') {
              setFormData((prev) => ({
                ...prev,
                uploadAddress: results[0].formatted_address,
                loadingCity:
                  addressComponents.find((c) => c.types.includes('administrative_area_level_1'))
                    ?.long_name || prev.loadingCity,
                loadingCountry:
                  addressComponents.find((c) => c.types.includes('country'))
                    ?.short_name || prev.loadingCountry,
                loadingLatitude: lat.toString(),
                loadingLongitude: lng.toString(),
              }));
              alert('Yükleme adresi başarıyla bulundu!');
            } else if (addressType === 'discharge') {
              setFormData((prev) => ({
                ...prev,
                unloadingAddress: results[0].formatted_address,
                evacuationCity:
                  addressComponents.find((c) => c.types.includes('administrative_area_level_1'))
                    ?.long_name || prev.evacuationCity,
                dischargeCountry:
                  addressComponents.find((c) => c.types.includes('country'))
                    ?.short_name || prev.dischargeCountry,
                dischargeLatitude: lat.toString(),
                dischargeLongitude: lng.toString(),
              }));
              alert('Boşaltma adresi başarıyla bulundu!');
            } else if (addressType === 'new') {
              setNewAddress((prev) => ({
                ...prev,
                description: results[0].formatted_address,
                city:
                  addressComponents.find((c) => c.types.includes('administrative_area_level_1'))
                    ?.long_name || '',
                state:
                  addressComponents.find((c) =>
                    c.types.includes('administrative_area_level_1')
                  )?.long_name || '',
                country:
                  addressComponents.find((c) => c.types.includes('country'))
                    ?.short_name || '',
                latitude: lat.toString(),
                longitude: lng.toString(),
              }));
              setAddressSearchQuery(results[0].formatted_address);
              alert('Adres başarıyla bulundu!');
            }
          } else {
            alert('Bu koordinatlar için adres bulunamadı.');
          }
        });
      } else {
        alert('Google Maps yüklenemedi. Lütfen daha sonra tekrar deneyin.');
      }
      return true;
    } else {
      alert('Lütfen geçerli koordinat değerleri girin.');
      return false;
    }
  };

  // Add a geocode function to the component to handle address geocoding in multiple places
  const geocodeAddress = (address) => {
    if (!address || !window.google || !window.google.maps) return;

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        const lat = location.lat();
        const lng = location.lng();

        // Set the selected location for the map marker
        setSelectedAddressLocation({ lat, lng });

        // Update the viewport to center on this location
        setViewport({
          center: { lat, lng },
          zoom: 14,
        });

        // Update the address data with coordinates and components
        const addressComponents = results[0].address_components;
        setNewAddress((prev) => ({
          ...prev,
          description: results[0].formatted_address,
          city:
            addressComponents.find((c) => c.types.includes('administrative_area_level_1'))
              ?.long_name || '',
          state:
            addressComponents.find((c) =>
              c.types.includes('administrative_area_level_1')
            )?.long_name || '',
          country:
            addressComponents.find((c) => c.types.includes('country'))
              ?.short_name || '',
          latitude: lat.toString(),
          longitude: lng.toString(),
        }));

        // Show the map to display the found location
        setIsAddressMapVisible(true);
      } else {
        // Show error if geocoding failed
        alert(
          'Adres için konum bulunamadı. Lütfen daha spesifik bir adres girin.'
        );
      }
    });
  };

  // Add a function to handle customs modal success
  const handleCustomsSuccess = async () => {
    try {
      // Refetch customs addresses
      const { data, error } = await supabase.from('customs').select('*');
      if (error) throw error;
      setCustomsAddresses(data || []);
      
      // Close the customs modal
      setOpenCustomsModal(false);
      setSelectedCustoms(null);
    } catch (error) {
      console.error('Error fetching customs addresses:', error);
    }
  };

  // Add a function to handle new instruction template submission
  const handleInstructionTemplateSubmit = async () => {
    try {
      // Validate form
      if (
        !newInstructionTemplate.name ||
        !newInstructionTemplate.content ||
        !newInstructionTemplate.type
      ) {
        alert('Lütfen tüm alanları doldurunuz');
        return;
      }

      // Save to database
      const { data, error } = await supabase
        .from('instruction_templates')
        .insert([
          {
            name: newInstructionTemplate.name,
            content: newInstructionTemplate.content,
            type: newInstructionTemplate.type,
          },
        ]);

      if (error) throw error;

      // Refresh instruction templates
      const { data: templates, error: fetchError } = await supabase
        .from('instruction_templates')
        .select('*');

      if (fetchError) throw fetchError;
      setInstructionTemplates(templates || []);

      // Close modal
      setOpenInstructionModal(false);

      // Reset form
      setNewInstructionTemplate({
        name: '',
        content: '',
        type: 'loading',
      });

      // Show success message
    } catch (error) {
      console.error('Error saving instruction template:', error);
      alert('Şablon eklenirken bir hata oluştu');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-60">
      <div className="relative top-20 mx-auto p-5 border max-w-4xl shadow-lg rounded-md bg-white">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl leading-6 font-medium text-gray-900">
            {load ? 'Yük Düzenle' : 'Yeni Yük Ekle'}
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
            aria-label="Close"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="mt-3">
          {Object.keys(errors).length > 0 && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
              Lütfen tüm gerekli alanları doldurunuz.
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Genel Bilgiler */}
            <div className="bg-white p-6 rounded-lg border-2">
              <h2 className="text-xl font-semibold mb-4">Genel Bilgiler</h2>
              <div className="space-y-4">
                <CustomerAutocomplete
                  value={formData.customerName}
                  onChange={(value) => {
                    setFormData((prev) => ({
                      ...prev,
                      customerName: value,
                    }));
                  }}
                  options={customers}
                  label="Müşteri"
                  onAddNew={handleOpenCustomerModal}
                  placeholder="Müşteri ara..."
                  error={!!errors.customerName}
                  errorMessage={errors.customerName}
                />
                <div>
                  <label className="block text-sm font-medium mb-2">
                    Pazar Durumu <span className="text-red-500">*</span>
                  </label>
                  <div className="space-x-4">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="marketStatus"
                        checked={formData.on_market}
                        onChange={() =>
                          setFormData((prev) => ({ ...prev, on_market: true }))
                        }
                        className="form-radio h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                      />
                      <span className="ml-2">Açık</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="marketStatus"
                        checked={!formData.on_market}
                        onChange={() =>
                          setFormData((prev) => ({ ...prev, on_market: false }))
                        }
                        className="form-radio h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                      />
                      <span className="ml-2">Kapalı</span>
                    </label>
                  </div>
                </div>

                {renderInput(
                  'referenceNumber',
                  'Referans Numarası',
                  'text',
                  false,
                  false
                )}

                <div className="grid grid-cols-2 gap-4">
                  <SenderReceiverCompanyAutocomplete
                    value={formData.senderCompany}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        senderCompany: value,
                      }));
                    }}
                    options={senderReceiverCompanies}
                    label="Gönderici Firma"
                    companyType="sender"
                    placeholder="Gönderici firma ara..."
                    onAddNew={handleOpenCompanyModal}
                  />
                  <SenderReceiverCompanyAutocomplete
                    value={formData.receiverCompany}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        receiverCompany: value,
                      }));
                    }}
                    options={senderReceiverCompanies}
                    label="Alıcı Firma"
                    companyType="receiver"
                    placeholder="Alıcı firma ara..."
                    onAddNew={handleOpenCompanyModal}
                  />
                </div>

                <OperationAuthAutocomplete
                  value={formData.operation_auth_id}
                  onChange={(value) => {
                    setFormData((prev) => ({
                      ...prev,
                      operation_auth_id: value,
                    }));
                  }}
                  options={operationAuths}
                  label="Operasyon Yetkilisi"
                  placeholder="Operasyon yetkilisi ara..."
                />
              </div>
            </div>

            {/* Yükleme Yeri Bilgileri */}
            <div className="bg-white p-6 rounded-lg border-2">
              <h2 className="text-xl font-semibold mb-4">
                Yükleme Yeri Bilgileri
              </h2>
              <div className="space-y-4">
                <AddressAutocomplete
                  value={formData.uploadAddress}
                  onChange={(value) => {
                    setFormData((prev) => ({
                      ...prev,
                      uploadAddress: value,
                    }));

                    // Find the address in savedAddresses
                    const selectedAddress = savedAddresses.find(
                      (addr) => addr.description === value
                    );

                    if (selectedAddress) {
                      setSelectedLoadingAddressId(
                        selectedAddress.id.toString()
                      );
                      handleSavedAddressSelect(selectedAddress, 'loading');
                    } else {
                      setSelectedLoadingAddressId('');
                    }
                  }}
                  options={savedAddresses}
                  label="Yükleme Adresi"
                  onAddNew={() => setOpenAddressModal(true)}
                  placeholder="Yükleme adresi ara..."
                  error={!!errors.uploadAddress}
                  errorMessage={errors.uploadAddress}
                />

                {/* Coordinates display */}

                <div>
                  {renderInput(
                    'loading_date',
                    'Yükleme Tarihi',
                    'date',
                    false,
                    true
                  )}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  {renderSelect(
                    'loadingCountry',
                    'Ülke',
                    countries.map((country) => ({
                      value: country.code,
                      label: country.name_tr || country.name_en,
                    })),
                    false,
                    true
                  )}
                  {renderInput('loadingCity', 'Şehir', 'text', true, true)}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  {renderCustomsAddressSelect('loading')}
                  <InstructionAutocomplete
                    value={formData.loadingInstructions}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        loadingInstructions: value,
                      }));
                    }}
                    options={instructionTemplates}
                    label="Yükleme Talimatları"
                    type="loading"
                    onAddNew={() => {
                      setNewInstructionTemplate({
                        name: '',
                        content: '',
                        type: 'loading',
                      });
                      setOpenInstructionModal(true);
                    }}
                    placeholder="Yükleme talimatlarını girin..."
                  />
                </div>

                {/* Map Toggle Button for loading location */}
                <button
                  type="button"
                  onClick={() => setIsMapVisible(!isMapVisible)}
                  className="w-full px-4 py-2 text-left text-sm font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md flex items-center justify-between"
                >
                  <span>Yükleme Konumunu Haritada Göster</span>
                  <svg
                    className={`w-5 h-5 transform transition-transform ${
                      isMapVisible ? 'rotate-180' : ''
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {/* Map section for loading location */}
                {isMapVisible && (
                  <div className="relative h-[300px]">
                    <APIProvider
                      apiKey={googleMapsApiKey}
                      libraries={['places']}
                    >
                      <Map
                        zoom={viewport.zoom}
                        center={selectedLocation || viewport.center}
                        gestureHandling="greedy"
                        disableDefaultUI={false}
                        style={{
                          width: '100%',
                          height: '100%',
                          borderRadius: '0.375rem',
                        }}
                        onCameraChanged={(ev) => {
                          setViewport({
                            center: ev.detail.center,
                            zoom: ev.detail.zoom,
                          });
                        }}
                        onClick={(event) => {
                          const lat = event.detail.latLng.lat;
                          const lng = event.detail.latLng.lng;
                          setSelectedLocation({ lat, lng });

                          setViewport({
                            ...viewport,
                            center: { lat, lng },
                          });

                          // Check if Google Maps API is loaded
                          if (window.google && window.google.maps) {
                            const geocoder = new window.google.maps.Geocoder();
                            geocoder.geocode(
                              { location: { lat, lng } },
                              (results, status) => {
                                if (status === 'OK' && results[0]) {
                                  const addressComponents =
                                    results[0].address_components;
                                  setFormData((prev) => ({
                                    ...prev,
                                    uploadAddress: results[0].formatted_address,
                                    loadingCity:
                                      addressComponents.find((c) =>
                                        c.types.includes('administrative_area_level_1')
                                      )?.long_name || prev.loadingCity,
                                    loadingCountry:
                                      addressComponents.find((c) =>
                                        c.types.includes('country')
                                      )?.short_name || prev.loadingCountry,
                                  }));
                                }
                              }
                            );
                          }
                        }}
                      >
                        {selectedLocation && (
                          <Marker
                            position={{
                              lat: selectedLocation.lat,
                              lng: selectedLocation.lng,
                            }}
                          />
                        )}
                      </Map>
                    </APIProvider>
                  </div>
                )}
              </div>
            </div>

            {/* Boşaltma Yeri Bilgileri */}
            <div className="bg-white p-6 rounded-lg border-2">
              <h2 className="text-xl font-semibold mb-4">
                Boşaltma Yeri Bilgileri
              </h2>
              <div className="space-y-4">
                <AddressAutocomplete
                  value={formData.unloadingAddress}
                  onChange={(value) => {
                    setFormData((prev) => ({
                      ...prev,
                      unloadingAddress: value,
                    }));

                    // Find the address in savedAddresses
                    const selectedAddress = savedAddresses.find(
                      (addr) => addr.description === value
                    );

                    if (selectedAddress) {
                      setSelectedDischargeAddressId(
                        selectedAddress.id.toString()
                      );
                      handleSavedAddressSelect(selectedAddress, 'discharge');
                    } else {
                      setSelectedDischargeAddressId('');
                    }
                  }}
                  options={savedAddresses}
                  label="Boşaltma Adresi"
                  onAddNew={() => setOpenAddressModal(true)}
                  placeholder="Boşaltma adresi ara..."
                  error={!!errors.unloadingAddress}
                  errorMessage={errors.unloadingAddress}
                />

                {/* Coordinates display for discharge */}

                <div className="grid grid-cols-2 gap-4">
                  {renderSelect(
                    'dischargeCountry',
                    'Ülke',
                    countries.map((country) => ({
                      value: country.code,
                      label: country.name_tr || country.name_en,
                    })),
                    true,
                    true
                  )}
                  {renderInput('evacuationCity', 'Şehir', 'text', true, true)}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>{renderCustomsAddressSelect('discharge')}</div>
                  <InstructionAutocomplete
                    value={formData.dischargeInstructions}
                    onChange={(value) => {
                      setFormData((prev) => ({
                        ...prev,
                        dischargeInstructions: value,
                      }));
                    }}
                    options={instructionTemplates}
                    label="Boşaltma Talimatları"
                    type="discharge"
                    onAddNew={() => {
                      setNewInstructionTemplate({
                        name: '',
                        content: '',
                        type: 'discharge',
                      });
                      setOpenInstructionModal(true);
                    }}
                    placeholder="Boşaltma talimatlarını girin..."
                  />
                </div>

                {/* Map Toggle Button for discharge location */}
                <button
                  type="button"
                  onClick={() =>
                    setIsDischargeMapVisible(!isDischargeMapVisible)
                  }
                  className="w-full px-4 py-2 text-left text-sm font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md flex items-center justify-between mt-4"
                >
                  <span>Boşaltma Konumunu Haritada Göster</span>
                  <svg
                    className={`w-5 h-5 transform transition-transform ${
                      isDischargeMapVisible ? 'rotate-180' : ''
                    }`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {/* Map section for discharge location */}
                {isDischargeMapVisible && (
                  <div className="relative h-[300px]">
                    <APIProvider
                      apiKey={googleMapsApiKey}
                      libraries={['places']}
                    >
                      <Map
                        zoom={viewport.zoom}
                        center={selectedDischargeLocation || viewport.center}
                        gestureHandling="greedy"
                        disableDefaultUI={false}
                        style={{
                          width: '100%',
                          height: '100%',
                          borderRadius: '0.375rem',
                        }}
                        onCameraChanged={(ev) => {
                          setViewport({
                            center: ev.detail.center,
                            zoom: ev.detail.zoom,
                          });
                        }}
                        onClick={(event) => {
                          const lat = event.detail.latLng.lat;
                          const lng = event.detail.latLng.lng;
                          setSelectedDischargeLocation({ lat, lng });

                          setViewport({
                            ...viewport,
                            center: { lat, lng },
                          });

                          // Check if Google Maps API is loaded
                          if (window.google && window.google.maps) {
                            const geocoder = new window.google.maps.Geocoder();
                            geocoder.geocode(
                              { location: { lat, lng } },
                              (results, status) => {
                                if (status === 'OK' && results[0]) {
                                  setFormData((prev) => ({
                                    ...prev,
                                    dischargeLatitude: lat.toString(),
                                    dischargeLongitude: lng.toString(),
                                  }));
                                }
                              }
                            );
                          }
                        }}
                      >
                        {selectedDischargeLocation && (
                          <Marker
                            position={{
                              lat: selectedDischargeLocation.lat,
                              lng: selectedDischargeLocation.lng,
                            }}
                          />
                        )}
                      </Map>
                    </APIProvider>
                  </div>
                )}
              </div>
            </div>

            {/* Yük Bilgileri */}
            <div className="bg-white p-6 rounded-lg border-2">
              <h2 className="text-xl font-semibold mb-4">Yük Bilgileri</h2>
              {errors.loadDetails && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
                  {errors.loadDetails}
                </div>
              )}
              <div className="grid grid-cols-2 gap-4">
                {renderSelect('cargoType', 'Yük Tipi', [
                  { value: 'komple', label: 'Komple' },
                  { value: 'parsiyel', label: 'Parsiyel' },
                ])}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Araç Cinsi
                  </label>
                  <Select
                    multiple
                    value={formData.vehicleTypes}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        vehicleTypes: e.target.value,
                      }))
                    }
                    input={<OutlinedInput />}
                    renderValue={(selected) => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                    className={`w-full ${
                      errors.vehicleTypes ? 'border-red-500' : ''
                    }`}
                    error={!!errors.vehicleTypes}
                  >
                    {vehicleTypeOptions.map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.vehicleTypes && (
                    <p className="error-message text-red-500 text-xs mt-1">
                      {errors.vehicleTypes}
                    </p>
                  )}
                </div>
                {renderInput('packageType', 'Kap Cinsi', 'text', false, false)}
                {renderInput('quantity', 'Adet', 'number', false, false)}
                {renderInput('product', 'Taşınan Ürün')}
                {renderInput('grossWeight', 'Brüt Ağırlık', 'number', false, false)}
                {renderInput(
                  'transitTime',
                  'Transit Süre',
                  'number',
                  false,
                  false
                )}
                <div className="grid grid-cols-2 gap-4">
                  {renderInput(
                    'goodsValue',
                    'Mal Değeri',
                    'number',
                    false,
                    false
                  )}
                  {renderSelect('goodsCurrency', 'Para Birimi', [
                    { value: 'USD', label: 'USD' },
                    { value: 'EUR', label: 'EUR' },
                    { value: 'TRY', label: 'TRY' },
                  ])}
                </div>
              </div>
            </div>

            {/* Form Actions */}
            <div className="flex justify-end space-x-4">
              <button
                type="button"
                onClick={onClose}
                className="px-6 py-2 border-2 rounded-md hover:bg-gray-50"
              >
                İptal
              </button>
              <button
                type="submit"
                className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                {load ? 'Değişiklikleri Kaydet' : 'Kaydet'}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* New Address Modal */}
      {openAddressModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[600px] max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4">Yeni Adres Ekle</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Adres Adı
                </label>
                <input
                  type="text"
                  value={newAddress.name}
                  onChange={(e) =>
                    setNewAddress({
                      ...newAddress,
                      name: e.target.value,
                    })
                  }
                  className="w-full border-2 rounded-md p-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Açık Adres
                </label>
                <textarea
                  value={addressSearchQuery}
                  onChange={(e) => setAddressSearchQuery(e.target.value)}
                  className="w-full border-2 rounded-md p-2"
                  rows="3"
                  onBlur={() => {
                    // When user finishes typing and leaves the field, geocode the address
                    if (
                      addressSearchQuery &&
                      window.google &&
                      window.google.maps
                    ) {
                      geocodeAddress(addressSearchQuery);
                    }
                  }}
                ></textarea>
                <div className="flex justify-end mt-1">
                  <button
                    type="button"
                    onClick={() => geocodeAddress(addressSearchQuery)}
                    className="px-3 py-1 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700"
                  >
                    Konumu Bul
                  </button>
                </div>
              </div>

              {/* Map Toggle Button */}
              <button
                type="button"
                onClick={() => setIsAddressMapVisible(!isAddressMapVisible)}
                className="w-full px-4 py-2 text-left text-sm font-medium text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-md flex items-center justify-between"
              >
                <span>Haritada Göster</span>
                <svg
                  className={`w-5 h-5 transform transition-transform ${
                    isAddressMapVisible ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* Map Section */}
              {isAddressMapVisible && (
                <div className="relative h-[300px]">
                  <APIProvider
                    apiKey={googleMapsApiKey}
                    libraries={['places']}
                  >
                    <Map
                      zoom={viewport.zoom}
                      center={viewport.center}
                      gestureHandling="greedy"
                      disableDefaultUI={false}
                      style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '0.375rem',
                      }}
                      onCameraChanged={(ev) => {
                        setViewport({
                          center: ev.detail.center,
                          zoom: ev.detail.zoom,
                        });
                      }}
                      onClick={(event) => {
                        const lat = event.detail.latLng.lat;
                        const lng = event.detail.latLng.lng;
                        setSelectedAddressLocation({ lat, lng });

                        setViewport({
                          ...viewport,
                          center: { lat, lng },
                        });

                        // Check if Google Maps API is loaded
                        if (window.google && window.google.maps) {
                          const geocoder = new window.google.maps.Geocoder();
                          geocoder.geocode(
                            { location: { lat, lng } },
                            (results, status) => {
                              if (status === 'OK' && results[0]) {
                                const addressComponents =
                                  results[0].address_components;

                                // Update the address fields
                                setNewAddress((prev) => ({
                                  ...prev,
                                  description: results[0].formatted_address,
                                  city:
                                    addressComponents.find((c) =>
                                      c.types.includes('administrative_area_level_1')
                                    )?.long_name || '',
                                  state:
                                    addressComponents.find((c) =>
                                      c.types.includes(
                                        'administrative_area_level_1'
                                      )
                                    )?.long_name || '',
                                  country:
                                    addressComponents.find((c) =>
                                      c.types.includes('country')
                                    )?.short_name || '',
                                  latitude: lat.toString(),
                                  longitude: lng.toString(),
                                }));

                                // Also update the search query to show the found address
                                setAddressSearchQuery(
                                  results[0].formatted_address
                                );
                              } else {
                                alert('Bu koordinatlar için adres bulunamadı.');
                              }
                            }
                          );
                        }
                      }}
                    >
                      {selectedAddressLocation && (
                        <Marker
                          position={{
                            lat: selectedAddressLocation.lat,
                            lng: selectedAddressLocation.lng,
                          }}
                        />
                      )}
                    </Map>
                  </APIProvider>
                </div>
              )}

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Şehir
                  </label>
                  <input
                    type="text"
                    value={newAddress.city}
                    onChange={(e) =>
                      setNewAddress({ ...newAddress, city: e.target.value })
                    }
                    className="w-full border-2 rounded-md p-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Ülke</label>
                  <input
                    type="text"
                    value={newAddress.country}
                    onChange={(e) =>
                      setNewAddress({ ...newAddress, country: e.target.value })
                    }
                    className="w-full border-2 rounded-md p-2"
                  />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium mb-1">
                    X Koordinat
                  </label>
                  <input
                    type="text"
                    value={newAddress.latitude}
                    onChange={(e) =>
                      setNewAddress({ ...newAddress, latitude: e.target.value })
                    }
                    className="w-full border-2 rounded-md p-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Y Koordinat
                  </label>
                  <input
                    type="text"
                    value={newAddress.longitude}
                    onChange={(e) =>
                      setNewAddress({
                        ...newAddress,
                        longitude: e.target.value,
                      })
                    }
                    className="w-full border-2 rounded-md p-2"
                  />
                </div>
              </div>

              {/* Add button to find address from coordinates */}
              <div className="mt-2">
                <button
                  type="button"
                  onClick={() => {
                    // Check if both latitude and longitude are provided
                    if (newAddress.latitude && newAddress.longitude) {
                      const lat = parseFloat(newAddress.latitude);
                      const lng = parseFloat(newAddress.longitude);
                      findAddressFromCoordinates(lat, lng, 'new');
                    } else {
                      alert(
                        'Lütfen hem enlem hem de boylam değerlerini girin.'
                      );
                    }
                  }}
                  className="w-full py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
                >
                  Koordinatlardan Adres Bul
                </button>
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-4">
              <button
                onClick={() => setOpenAddressModal(false)}
                className="px-4 py-2 border rounded-md hover:bg-gray-50"
              >
                İptal
              </button>
              <button
                onClick={handleAddAddress}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Kaydet
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Customs Modal */}
      <CustomsModal
        isOpen={openCustomsModal}
        onClose={() => setOpenCustomsModal(false)}
        customs={selectedCustoms}
        onSuccess={handleCustomsSuccess}
      />

      {/* Add Instruction Template Modal */}
      {openInstructionModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-[600px] max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold mb-4">
              Yeni Talimat Şablonu Ekle
            </h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">
                  Şablon Adı
                </label>
                <input
                  type="text"
                  value={newInstructionTemplate.name}
                  onChange={(e) =>
                    setNewInstructionTemplate({
                      ...newInstructionTemplate,
                      name: e.target.value,
                    })
                  }
                  className="w-full border-2 rounded-md p-2"
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Şablon Tipi
                </label>
                <select
                  value={newInstructionTemplate.type}
                  onChange={(e) =>
                    setNewInstructionTemplate({
                      ...newInstructionTemplate,
                      type: e.target.value,
                    })
                  }
                  className="w-full border-2 rounded-md p-2"
                >
                  <option value="loading">Yükleme Talimatı</option>
                  <option value="discharge">Boşaltma Talimatı</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">
                  Şablon İçeriği
                </label>
                <textarea
                  rows="6"
                  value={newInstructionTemplate.content}
                  onChange={(e) =>
                    setNewInstructionTemplate({
                      ...newInstructionTemplate,
                      content: e.target.value,
                    })
                  }
                  className="w-full border-2 rounded-md p-2"
                ></textarea>
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-4">
              <button
                onClick={() => setOpenInstructionModal(false)}
                className="px-4 py-2 border rounded-md hover:bg-gray-50"
              >
                İptal
              </button>
              <button
                onClick={handleInstructionTemplateSubmit}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Kaydet
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Customer Modal */}
      <CustomerModal
        isOpen={isCustomerModalOpen}
        onClose={() => setIsCustomerModalOpen(false)}
        customer={null}
        onSave={handleCustomerSave}
      />

      {/* Add Company Modal */}
      <GondericiAliciFirmaModal
        isOpen={isCompanyModalOpen}
        onClose={() => setIsCompanyModalOpen(false)}
        company={null}
        onSave={handleCompanySave}
      />
    </div>
  );
};

export default LoadModal;